import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { CurrentLocationIcon } from '../../components/icons';
import { Box } from '@material-ui/core';

const styles = theme => ({
    icon_container:{
        width:40,
        height:40,
        borderRadius:40,
        justifyContent:'center',
        alignItems:'center',
        position:'absolute',
        top:10,
        right:10,
        backgroundColor: theme.palette.background.secondary,
        cursor:'pointer',
        opacity: 1,
        '&:hover': {
            opacity: 0.6,
        },

    },
    icon:{
        width:36,
        height:36,
        marginTop: theme.spacing(0.5),
        marginLeft: theme.spacing(0.5)
    }
});

class MyLocationIcon extends Component {
    render() {
        const { classes} = this.props;
        return (
            <Box className={classes.icon_container} onClick={this.props.onClick}>
                <CurrentLocationIcon className={classes.icon}/>
            </Box>
        );
    }
}
export default withStyles(styles)(withTranslation()(MyLocationIcon));